import React from "react";
import { View, Dimensions, ScrollView } from "react-native";

import ManaButton from "../common/ManaButton";
import appStyles from "../../appStyles";
import styles from "./emptyPageStyles";

const { height: HEIGHT, width: WIDTH } = Dimensions.get("window");

const GenericOverlay = (props) => {
  const { onButtonPress = () => {}, ImageTag } = props;

  return (
    <View style={styles.overlay}>
      <ScrollView>
        <ImageTag width={Math.min(411, WIDTH)} />
      </ScrollView>

      <View style={[appStyles.footerButtons, styles.overlayFooter]}>
        <ManaButton
          onPress={onButtonPress}
          style={styles.overlayButton}
          styleText={styles.overlayButtonText}
          text={"Got it!"}
        />
      </View>
    </View>
  );
};

export default GenericOverlay;
